export const OPTIONS_CHANGE_ACTION = 'optionsChangeAction';

export function changeOptions(optionsPath, value) {
	return {
		type: OPTIONS_CHANGE_ACTION,
		optionsPath,
		value
	};
}


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/plugins/GA/actions/index.js